module.exports = __webpack_public_path__ + "img/banner_about.6dc6f23f.png";